module.exports = __webpack_public_path__ + "static/media/Feeding_America_Logo.5339deb6.png";